import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'translations';
import Icon from 'components/icon';
import { Link } from 'react-router-dom';
import MainTitle from 'components/main-title';
import normaliseTrailingSlash from 'util/misc/normalise-trailing-slash';

export default function ProductsSliderHeader({ title, link, link_label_key = 'categories.all' }) {
    return (
        <header className="products-slider-header">
            <MainTitle className="main-title" text={title}/>
            {link !== null &&
            <Link
                className="products-slider-header--show-all u-reset"
                to={normaliseTrailingSlash(link)}
            >
                <Trans path={link_label_key}/>
                <Icon symbol="chevron-right" size="small"/>
            </Link>
            }
        </header>
    );
}
ProductsSliderHeader.propTypes = {
    title: PropTypes.string.isRequired,
    link: PropTypes.string,
    link_label_key: PropTypes.string,
};






// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/products-slider-header/index.js